import { createContext } from 'react';

import type { CarouselProps } from './carousel.types';

/**
 * CarouselContext to pass props to Carousel subcomponents
 */

export const CarouselContext = createContext<
  Pick<
    CarouselProps,
    | 'containImages'
    | 'desktopHeight'
    | 'desktopWidth'
    | 'mobileHeight'
    | 'mobileWidth'
    | 'onVideoClick'
    | 'responsive'
    | 'stockPhoto'
  >
>({
  containImages: false,
  desktopHeight: '',
  desktopWidth: '',
  mobileHeight: '',
  mobileWidth: '',
  onVideoClick: () => {},
  responsive: false,
  stockPhoto: false,
});
